import { CountryCode, parsePhoneNumber } from "libphonenumber-js";
import countries from "countries-phone-masks";
import { PhoneInputValue, Country } from "../types";

const countriesMasks = countries as unknown as Country[];

export const phoneStringToInputValue = (phoneStr: string): PhoneInputValue => {
  let country: Country | undefined;
  if (phoneStr?.startsWith("91") || phoneStr?.startsWith("+91")) {
    country = countriesMasks.find((item) => item.iso === "IN");
  } else if (phoneStr?.startsWith("1") || phoneStr?.startsWith("+1")) {
    country = countriesMasks.find((item) => item.iso === "US");
  } else {
    country = countriesMasks.find((item) => phoneStr?.indexOf(item.code) === 0);
  }

  const phone = phoneStr && country ? phoneStr.slice(country.code.length) : "";
  const code = country?.code || "+91";
  const iso = country?.iso || "IN";
  let phoneNumber;
  try {
    phoneNumber = parsePhoneNumber(`${code}${phone}`, iso as CountryCode);
  } catch (error) {
    //
  }

  return {
    iso: country?.iso || "IN",
    code,
    phone,
    isValid: /000\d\d\d\d000/g.test(phone) || phoneNumber?.isValid() || false,
  };
};
